import { memo, useEffect } from "react";
import playCursorImg from "../../assets/images/play-cursor.png";
import pauseCursorImg from "../../assets/images/pause-cursor.png";
import defaultCursorImg from "../../assets/images/default-cursor.png";

export enum FAVICON_ENUM {
  PLAY = "PLAY",
  PAUSE = "PAUSE",
  DEFAULT = "DEFAULT",
};

// export type FAVICON_ICONS = keyof typeof FAVICON_ENUM;

interface FaviconImages { [key: string]: string };

export const FAVICON_IMAGES: FaviconImages = {
  PLAY: playCursorImg,
  PAUSE: pauseCursorImg,
  DEFAULT: defaultCursorImg,
};

export interface FaviconProps {
  icon?: FAVICON_ENUM;
  href?: string;
}

const Favicon = ({ icon, href }: FaviconProps) => {
  useEffect(() => {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";

      document.getElementsByTagName("head")[0].appendChild(link);
    }
    if (href) {
      link.href = href;
    } else if (icon && FAVICON_IMAGES[icon]) {
      link.href = FAVICON_IMAGES[icon];
    }
  }, [icon, href]);
  return null;
};

const areEqual = (
  prevProps: Readonly<FaviconProps>,
  nextProps: Readonly<FaviconProps>
) => prevProps.icon === nextProps.icon && prevProps.href === nextProps.href;

export default memo(Favicon, areEqual);
